import EditParking from './CreateParking';

export default EditParking;
